/**
 * UI-related translations for Chinese (Traditional) language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: '複製連結',
    discord: 'Discord',
    leaveGame: '離開遊戲',
    joinGame: '加入遊戲',
    lockGame: '鎖定遊戲',
    unlockGame: '解鎖遊戲',
    startGame: '開始遊戲',
    options: '選項',
  },
  onlineStatus: {
    connecting: '連線中...',
    connected: '上線',
    error: '連線失敗',
  },
  profile: {
    username: '使用者名稱',
    stats: '統計',
    logout: '登出',
    language: '語言',
    hideSpoilersHint: '隱藏劇透',
    hideIndexHint: '隱藏歷史索引',
    animeMode: '動漫模式',
    update: '更新',
    colorTheme: '色彩主題',
    darkTheme: '深色主題',
    lightTheme: '淺色主題',
    profile: '個人資料',
    change: '更改',
    changePassword: '更改密碼',
    settings: '設定',
  },
  breadCrumbs: {
    merlin: '梅林',
    merlin_pure: '終極梅林',
    guinevere: '女皇',
    percival: '派西維爾',
    lovers: '戀人',
    troublemaker: '麻煩友',
    servant: '僕人',
    lancelots: '蘭斯洛特',
    mordred: '莫德雷德',
    trickster: '騙子',
    revealer: '被揭示者',
    morgana: '莫甘娜',
    oberon: '奧伯倫',
    lunatic: '瘋子',
    brute: '野蠻人',
    witch: '巫婆',
    minion: '士兵',
    cleric: '牧師',
    wiki: '維基',
    expansions: '插件',
    roles: '角色',
    lady: '湖中仙女',
    lady_sea: '海中仙女',
    plot_cards: '情節卡',
    excalibur: '神劍',
    rules: '規則',
  },
  hostMenu: {
    host: '房主',
    hostPanel: '房主面板',
    endRestartGameHint: '開始投票,決定遊戲結束或重新開始',
    endGame: '遊戲結束',
    restartGame: '重新開始遊戲',
    shuffle: '隨機換位',
    shuffleHint: '隨機調整大廳中玩家的位置',
  },
  cardsInfo: {
    cards: '卡牌',
    usedCards: '已使用的卡牌',
    remainingCards: '剩餘卡牌',
    leadToVictory: '引領勝利',
    leadToVictoryHint: '在隊伍選擇前成為領袖',
    ambush: '埋伏',
    ambushHint: '揭示一張任務卡的結果',
    kingReturns: '王者歸來',
    kingReturnsHint: '取消已批准的任務並將領導權移交給下一位玩家',
    restoreHonor: '恢復榮譽',
    restoreHonorHint: '從任意玩家處拿取情節卡',
    charge: '指控',
    chargeHint: '強制玩家公開投票',
    showNature: '展現真我',
    showNatureHint: '向另一玩家展示你的忠誠',
    areYouTheOne: '天命之人',
    areYouTheOneHint: '檢查相鄰玩家的忠誠',
    weFoundYou: '找到你了',
    weFoundYouHint: '強制一名玩家正面打出任務卡',
    showStrength: '展示力量',
    showStrengthHint: '領袖向玩家揭示其忠誠',
  },
  avatars: {
    modalHeader: '選擇頭像',
    servantHint: '預設頭像',
    lady_of_lakeHint: '頒發給2025年註冊的用戶',
    mysteryHint: '授予發現網站上秘密的用戶',
    merlin_pureHint: '頒發給幫助項目反饋/幫助尋找錯誤的用戶',
    'anime/merlin_pureHint': '頒發給在GitHub上對項目代碼做出任何貢獻的用戶',
    'anime/witchHint': '授予在任何角色上獲得第一名評分的玩家',
  },
  spoiler: {
    spoiler: '劇透',
    spoilerHint: '該內容隱藏在劇透下方,因為它包含其他玩家不知道的訊息',
  },
  previewLink: {
    'Minions of Mordred(*)': '莫德雷德的爪牙(*)',
    Minions: '士兵',
  },
  chartStats: {
    countPlayer: '{playerCount} 名玩家',
    evilWinrate: '黑暗陣營勝率',
    goodWinrate: '光明陣營勝率',
    winrateByTeamSize: '根據隊伍規模的勝率',
    halfWinrate: '50% 勝率',
  },
  inGame: {
    sendTeam: '發送組隊',
    approve: '同意',
    reject: '拒絕',
    success: '成功',
    fail: '失敗',
    checkLoyalty: '檢查忠誠度',
    giveExcalibur: '給予神劍',
    skipExcalibur: '跳過神劍',
    useExcalibur: '使用神劍',
    useWitchAbility: '隱藏任務',
    skipWitchAbility: '跳過',
    giveCard: '給卡',
    takeLead: '成為領袖',
    skip: '跳過',
    useCard: '使用{cardName}',
    skipCard: '跳過{cardName}',
    selectPlayer: '選擇一名玩家',
    selectSinglePlayer: '請只選擇一名玩家',
    cannotSelectSelf: '你不能選擇自己',
    takeCard: '拿取卡牌',
    selectCard: '選擇一張卡牌',
    noAvailableCards: '沒有可用的卡牌',
    revealLoyalty: '揭示忠誠',
  },
};
